import SvgIcons from "../../../shared/components/svgIcons";
import Rollup from "../components/rollup";

// Hardcoded flag - set to true to hide, false to show
const isRollupEmpty = true;

const rollupRoute = [
  {
    path: "rollup",
    element: <Rollup />,
    link: "rollup",
    name: "Rollup",
    permission: "Rollup",
    icon: SvgIcons.ReportIcon,
    index: 6,
    hidden: isRollupEmpty,
  },
];
export default rollupRoute;
